import { render, staticRenderFns } from "./OrderReviews.vue?vue&type=template&id=6d89851e&scoped=true&"
import script from "./OrderReviews.vue?vue&type=script&lang=js&"
export * from "./OrderReviews.vue?vue&type=script&lang=js&"
import style0 from "./OrderReviews.vue?vue&type=style&index=0&id=6d89851e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d89851e",
  null
  
)

export default component.exports